import { productCodeIncludes } from '@/helpers/agencyProductCodes';
import { AgencyProduct, AgencyProductCodes } from '@/types-agency';

export const hasVisibilityLightAccess = (products: Array<AgencyProduct> | undefined): boolean =>
  !!products &&
  products.some((product) =>
    productCodeIncludes(product.productCode, [AgencyProductCodes.VISIBILITY_LIGHT]),
  );

const newConstructionLightProductCodes = [
  AgencyProductCodes.NEW_CONSTRUCTION_LIGHT_PRIMARY,
  AgencyProductCodes.NEW_CONSTRUCTION_LIGHT_LEGACY_CODE,
];

export const hasNewConstructionLightProduct = (
  products: Array<AgencyProduct> | undefined,
): boolean =>
  !!products &&
  products.some((product) =>
    productCodeIncludes(product.productCode, newConstructionLightProductCodes),
  );
